import { render, staticRenderFns } from "./GraphicArea.vue?vue&type=template&id=2228c09a&scoped=true&"
import script from "./GraphicArea.vue?vue&type=script&lang=js&"
export * from "./GraphicArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2228c09a",
  null
  
)

export default component.exports